// extracted by mini-css-extract-plugin
export default {"pagePaper":"styles_pagePaper__0sKsZ"};